import { getRequest } from "../config/AxiosConfig"

export const verifyIfscCodeService =async (ifsc) => {
    try {
        let response = await getRequest({
            url: 'https://ifsc.razorpay.com/' + ifsc
        });
        return response;
    } catch (error) {
        return error
    }
}